import { type FC } from 'react';

import { useEnergyCountdown } from '@wwe-portal/ui/lib/hooks/use-energy-countdown';

import { IcoMoonIcon } from '@wwe-portal/ui/components/icons/icomoon';
import { cn } from '@wwe-portal/ui/lib/lib';

export interface EnergyCountDownProps {
  endDate: string | undefined;
  className?: string;
  onEndCountDown: () => void;
  stepTime?: number;
}

export const EnergyCountDown: FC<EnergyCountDownProps> = ({
  endDate,
  className,
  onEndCountDown,
}) => {
  const { getTimeText, ended, isRefreshing } = useEnergyCountdown({
    endDate,
    onEndCountDown,
    refreshInterval: 30000, // Refresh every 30 seconds when close to end
  });

  // Don't render if no endDate is provided
  if (!endDate) return null;

  // Don't render if timer has ended
  if (ended) return null;

  return (
    <div className="text-text400 flex justify-between text-xs font-normal">
      <span>Energy Refresh</span>
      <div className={cn('flex items-center', className)}>
        <IcoMoonIcon
          iconName="timer"
          className={cn('mb-[2px] mr-[1px] size-4', {
            'animate-pulse': isRefreshing,
          })}
        />
        {getTimeText()}
      </div>
    </div>
  );
};
